import React from "react";
import { Link } from "react-router-dom";
import Close from "../assets/svg/close.svg";
import { motion } from "framer-motion";
import { connect } from "react-redux";

import { signOut } from "../store/actions/authActions";
import Facebook from "../assets/svg/facebook.svg";

function MenuFunc(props) {
  const { off, profile, auth, display } = props;
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
  return (
    <motion.div
      className="Yalla"
      style={{
        background: "#EE1D52",
        padding: "20px",
        position: "absolute",
        zIndex: 9999999,
        overflow: "hidden",
        display: display ? "inline" : "none",
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", duration: 0.4 }}
    >
      <div style={{ float: "left", marginLeft: "5px", marginTop: "5px" }}>
        <span style={{ fontSize: "24px", fontWeight: 600 }}>
          <Link to="/" style={{ color: "white", textDecoration: "none" }}>
            BoxFit
          </Link>
        </span>
      </div>

      <div
        onClick={(e) => off(false)}
        style={{ float: "right", marginRight: "5px" }}
      >
        <img src={Close} alt="close" style={{ maxHeight: "30px" }}></img>
      </div>
      <div
        style={{ paddingTop: "55px", borderBottom: "1px solid white" }}
      ></div>
      <div
        style={{
          paddingLeft: "6px",
          paddingTop: "20px",
          overflowY: "scroll",
          WebkitOverflowScrolling: "touch",
          height: "100%",
          width: "100%",
        }}
        className="yalla"
      >
        {!auth.uid ? (
          <div>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>COMPTE</span>

            <ul
              style={{
                fontSize: "20px",
                marginLeft: "-15px",
                marginTop: "7px",
              }}
              className="listaa"
            >
              {/*<li>*/}
              {/*  <Link style={{ color: "white" }} to="/upgrade">*/}
              {/*    Version Premium{" "}*/}
              {/*    <span role="img" aria-label="like">*/}
              {/*      🔥*/}
              {/*    </span>*/}
              {/*  </Link>*/}
              {/*</li>*/}
              <li>
                <Link style={{ color: "white" }} to="/login">
                  Connexion
                </Link>
              </li>
              <li>
                <Link style={{ color: "white" }} to="/register">
                  Créer compte
                </Link>
              </li>
            </ul>
          </div>
        ) : auth.uid && !profile.isPremium ? (
          <div>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>ACCOUNT</span>

            <ul
              style={{
                fontSize: "20px",
                marginLeft: "-15px",
                marginTop: "7px",
              }}
              className="listaa"
            >
              {/*<li>*/}
              {/*  <Link style={{ color: "white" }} to="/upgrade">*/}
              {/*    Version Premium{" "}*/}
              {/*    <span role="img" aria-label="like">*/}
              {/*      🔥*/}
              {/*    </span>*/}
              {/*  </Link>*/}
              {/*</li>*/}
              <li>
                <Link style={{ color: "white" }} to="/account">
                  Paramètres
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: "white" }}
                  onClick={() => {
                    props.signOut();
                  }}
                  to="#"
                >
                  Se déconnecter
                </Link>
              </li>
            </ul>
          </div>
        ) : (
          <div>
            <span style={{ fontSize: "18px", fontWeight: 600 }}>COMPTE</span>

            <ul
              style={{
                fontSize: "20px",
                marginLeft: "-15px",
                marginTop: "7px",
              }}
              className="listaa"
            >
              <li>
                <Link style={{ color: "white" }} to="/radar">
                  Weight Radar{" "}
                  <span role="img" aria-label="like">
                    ⭐
                  </span>
                </Link>
              </li>
              <li>
                <Link style={{ color: "white" }} to="/history">
                  Historique entraînement{" "}
                  <span role="img" aria-label="like">
                    ⭐
                  </span>
                </Link>
              </li>
              <li>
                <Link style={{ color: "white" }} to="/account">
                  Paramètres
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: "white" }}
                  onClick={() => {
                    props.signOut();
                  }}
                  to="#"
                >
                  Se déconnecter
                </Link>
              </li>
            </ul>
          </div>
        )}

        <span style={{ fontSize: "18px", fontWeight: 600 }}>EXERCICES</span>

        <ul
          style={{ fontSize: "20px", marginLeft: "-15px" }}
          className="listaa"
        >
          <li>
            <Link style={{ color: "white" }} to="/select-workout">
              Commencer nouvelle session
            </Link>
          </li>
        </ul>

        <span style={{ fontSize: "18px", fontWeight: 600 }}>AIDE</span>

        <ul
          style={{ fontSize: "20px", marginLeft: "-15px" }}
          className="listaa"
        >
          <li>
            <Link style={{ color: "white" }} to="/support">
              Support
            </Link>
          </li>
          <li>
            <Link style={{ color: "white" }} to="/terms">
              Termes et conditions
            </Link>
          </li>
          <li>
            <Link style={{ color: "white" }} to="/privacy">
              Politique de confidentialité
            </Link>
          </li>
        </ul>

        <span style={{ fontSize: "18px", fontWeight: 600 }}>RESTEZ EN FORME</span>

        <ul
          style={{ fontSize: "20px", marginLeft: "-15px" }}
          className="listaa"
        >
          <li>
            <Link style={{ color: "white" }} to="/best-glute-exercises">
              Les meilleurs exercices pour fessiers
            </Link>
          </li>
          <li>
            <Link style={{ color: "white" }} to="/8-minutes-abs">
              Session 8 Minutes Abdos
            </Link>
          </li>
          <li>
            <Link style={{ color: "white" }} to="/ultimate-bicep-curls">
              Session ultime pour Biceps
            </Link>
          </li>

          <li>
            <Link style={{ color: "white" }} to="/pilates-exercises">
              Excercices Pilates pour la maison
            </Link>
          </li>

          <li>
            <Link style={{ color: "white" }} to="/ball-exercises">
              Session Ball
            </Link>
          </li>

          <li>
            <Link style={{ color: "white" }} to="/perfect-ab-workout">
              La session parfaite d'abdos
            </Link>
          </li>
        </ul>

        <div style={{ height: "40px" }}></div>

        <span style={{ fontSize: "16px", fontWeight: 400 }}>
          &copy; 2023 BoxFit - All rights reserved.
        </span>

        <div style={{ height: "320px" }}></div>
      </div>
    </motion.div>
  );
}

function mapStateToProps(state) {
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
  return { auth: state.firebase.auth, profile: state.firebase.profile };
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuFunc);
